import ModalDeleteFilled from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'


interface ModalDeleteWorkingCenterShift4DeviceProps extends ModalEditComponentProps { }

const ModalDeleteWorkingCenterShift4Device: React.FC<ModalDeleteWorkingCenterShift4DeviceProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()

    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/workingCenter/workingCenterShift4Device/updateWorkingCenterShift4Device',
        data: {
            id: allRowData?.id,
            active: !allRowData?.active
        }
    })
    let translations = {
        title: t('sureUnableWorkingCenterShift4Device', '¿Seguro quieres desactivar este dispositivo de este centro de trabajo?'),
        subtitle: t('onceDeletedCouldBeRecovered', 'Una vez desactivado se podrá reactivar de nuevo'),
        buttonAccept: t('unable', 'Desactivar')
    }
    if (!allRowData?.active) {
        translations = {
            title: t('sureEnableWorkingCenterShift4Device', '¿Seguro quieres activar este dispositivo del centro de trabajo?'),
            subtitle: t('onceEnabledCouldBeDeletedF', 'Una vez activada se podrá desactivar de nuevo'),
            buttonAccept: t('enable', 'Activar')
        }
    }
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={translations} />
    )
}

export default ModalDeleteWorkingCenterShift4Device